import { api } from "./client";

// Ortak import API tipleri (Eğitmen + Araç toplu yukleme).
// Students-import kendi types'ina sahip; regression olmamasi icin bu dosya yeni modullerle sinirli.

export type ImportRowData = Record<string, string | undefined>;

export type ImportRowReport =
  | {
      row_number: number;
      status: "valid";
      data?: ImportRowData;
    }
  | {
      row_number: number;
      status: "error";
      error: { message: string; field?: string };
      data?: ImportRowData;
    };

export type ImportSummary = {
  dry_run: boolean;
  total_rows: number;
  valid_count: number;
  error_count: number;
  inserted_count: number;
  rows: ImportRowReport[];
};

export type ImportEndpoint = {
  templatePath: string;        // ornek: "/instructors/import/template"
  importPath: string;          // ornek: "/instructors/import"
  templateFilename: string;    // ornek: "egitmen-import-şablonu.xlsx"
};

export async function downloadImportTemplate(endpoint: ImportEndpoint): Promise<void> {
  const blob = await api.getBlob(endpoint.templatePath);
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = endpoint.templateFilename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function uploadImportXlsx(
  endpoint: ImportEndpoint,
  file: File,
  options: { dryRun?: boolean; branchId?: string } = {},
): Promise<ImportSummary> {
  const form = new FormData();
  form.append("file", file);
  const params = new URLSearchParams();
  if (options.dryRun) params.append("dry_run", "true");
  if (options.branchId) params.append("branch_id", options.branchId);
  const path = params.toString()
    ? `${endpoint.importPath}?${params.toString()}`
    : endpoint.importPath;
  return api.upload<ImportSummary>(path, form);
}

// ========== Modul bazli endpoint sabitleri ==========

export const INSTRUCTORS_IMPORT: ImportEndpoint = {
  templatePath: "/instructors/import/template",
  importPath: "/instructors/import",
  templateFilename: "egitmen-import-şablonu.xlsx",
};

export const VEHICLES_IMPORT: ImportEndpoint = {
  templatePath: "/vehicles/import/template",
  importPath: "/vehicles/import",
  templateFilename: "arac-import-şablonu.xlsx",
};
